<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center justify-space-between">
          <h1 class="headline">{{ $t('weekendScheldule.title') }}</h1>

          <v-btn
            v-if="$can('weekend_schedule_create')"
            color="warning mt-2"
            large
            depressed
            @click="dialog.opened = true"
          >
            {{ $t('weekendScheldule.add') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        class="weekend-schedule__table"
        :headers="headers"
        :items="list"
        :loading="loading"
      >
        <template #[`item.name`]="{item}">
          <button
            class="edit-btn"
            :disabled="!$can('weekend_schedule_edit')"
            @click="
              () => {
                dialog.editData = item;
                dialog.opened = true;
              }
            "
          >
            {{ item.name }}
          </button>
        </template>

        <template #[`item.description`]="{item}">
          {{ item.description || '—' }}
        </template>
      </v-data-table>
    </v-flex>

    <weekend-schedule-dialog
      v-model="dialog.opened"
      :edit-data.sync="dialog.editData"
      @update="proccessResult"
    />

    <v-snackbar v-model="snack.opened" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import WeekendScheduleDialog from '@/components/weekend-schedule/WeekendScheduleDialog.vue';

export default {
  components: { WeekendScheduleDialog },
  data: () => ({
    dialog: {
      opened: false,
      editData: null,
    },
    loading: false,

    snack: {
      opened: false,
      message: '',
      color: '',
    },
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t('weekendScheldule.name'),
          value: 'name',
          sortable: false,
        },
        {
          text: this.$t('weekendScheldule.workDays'),
          value: 'workdays_count',
          sortable: false,
        },
        {
          text: this.$t('weekendScheldule.weekend'),
          value: 'weekend_count',
          sortable: false,
        },
        {
          text: this.$t('common.table.description'),
          value: 'description',
          sortable: false,
        },
      ];
    },
    list() {
      return this.$store.state['weekend-schedule'].list;
    },
  },
  methods: {
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch('weekend-schedule/fetchList');
      this.loading = false;
    },
    proccessResult({ success }) {
      const snack = {
        opened: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (success) {
        this.fetchList();
        this.dialog.opened = false;
      } else {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      }

      this.snack = snack;
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss">
.weekend-schedule {
  &__table {
    margin-top: 35px;

    .v-data-footer {
      padding: 8px 0;

      &__select {
        display: none;
      }

      button {
        text-decoration: none !important;
      }
    }
  }
}

.edit-btn {
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.3;
  text-decoration: none;

  &[disabled] {
    font-weight: normal;
  }

  &:not([disabled]):hover {
    opacity: 0.7;
  }
}
</style>
